import React from "react";
import styled from "styled-components";

function VideoPreview({ fileUrl, onClick, style, videoStyle }) {
  if (!fileUrl) return null; // fileUrl이 없을 경우 렌더링하지 않음

  return (
    <VideoPreviewWrapper style={{ ...style }}>
      <video
        style={{
          width: "90px",
          height: "90px",
          borderRadius: "3px",
          objectFit: "cover",
          ...videoStyle,
        }}
        src={fileUrl}
        muted
        playsInline
        controls={false} // 컨트롤 표시 안 함
        onClick={(e) => e.preventDefault()} // 클릭 시 재생 방지
      />
      <DeleteIcon
        src="/assets/admin/icons/ico_img_del.svg"
        alt="삭제 아이콘"
        onClick={onClick}
      />
    </VideoPreviewWrapper>
  );
}

export default VideoPreview;

// 스타일 컴포넌트
const VideoPreviewWrapper = styled.div`
  position: relative;
  width: 90px;
  height: 90px;
`;

const DeleteIcon = styled.img`
  position: absolute;
  top: 6px;
  right: 6px;
  cursor: pointer;
`;
